import { render, staticRenderFns } from "./TextWidget.vue?vue&type=template&id=11223952&scoped=true"
import script from "./TextWidget.vue?vue&type=script&lang=js"
export * from "./TextWidget.vue?vue&type=script&lang=js"
import style0 from "./TextWidget.vue?vue&type=style&index=0&id=11223952&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11223952",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('11223952')) {
      api.createRecord('11223952', component.options)
    } else {
      api.reload('11223952', component.options)
    }
    module.hot.accept("./TextWidget.vue?vue&type=template&id=11223952&scoped=true", function () {
      api.rerender('11223952', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/templates/viewer/templateWidgets/TextWidget.vue"
export default component.exports